import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useStopwatchResultType } from 'react-timer-hook/dist/types/src/useStopwatch';

interface IProps {
	stopwatch: useStopwatchResultType;
}

const NUMBER_FORMAT = []

export default function Stopwatch(props: IProps) {
	const { seconds, minutes, hours, days, milliseconds } = props.stopwatch;
	
	return (
		<Row className="stopwatch">
			<Col>
				{/* {formatTime(props.stopwatch)} */}
				<span className="days">{days}</span>:<span className="hours">{hours.toLocaleString(undefined, {minimumIntegerDigits: 2})}</span>:<span className="minutes">{minutes.toLocaleString(undefined, {minimumIntegerDigits: 2})}</span>:<span className="seconds">{seconds.toLocaleString(undefined, {minimumIntegerDigits: 2})}</span>.<span className="milliseconds">{milliseconds.toLocaleString(undefined, {minimumIntegerDigits: 3})}</span>
			</Col>
		</Row>
	)
}
